import { Components, Inputs } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";

import { Divider } from "../../../../commonStyles";
import { FlexColumn, FlexRow } from "../../Styles";
import Snippet from "./Snippet";
import SocialShare from "./SocialShare";
import UserList from "./UserList";

const ShareModal = () => {
  const { typography } = useTheme();

  return (
    <FlexColumn $gapInPx={16}>
      <ShareModalHeader>
        <FlexRow $gapInPx={8}>
          <Components.Icon type="Share" size="32px" />
          <Components.Text
            text="Share"
            style={{ tokenStyle: typography.Heading.M }}
            fontWeight="font-weight-medium"
          />
        </FlexRow>
      </ShareModalHeader>
      <Divider />
      <ShareModalContent $gapInPx={16}>
        <UserList />
        <SocialContainer $gapInPx={8}>
          <Snippet />
          <SocialShare />
        </SocialContainer>
        <Inputs.Input
          size="Small"
          fieldName="copy-link"
          idPrefix="copy-link"
          isRequired={false}
          value="https://gorilla-frontend-nayan.ditto.work/"
          onChangeHandler={() => {}}
          iconType="Link"
          iconClickhandler={() => {
            navigator.clipboard.writeText(
              "https://gorilla-frontend-nayan.ditto.work/"
            );
          }}
        />
      </ShareModalContent>
      <Divider />
      <ShareModalFooter />
    </FlexColumn>
  );
};

export default ShareModal;

const ShareModalHeader = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-9"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem
    ${({ theme }) => theme.spacing["spacing-none"].value}rem;
`;

const ShareModalFooter = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

const ShareModalContent = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-none"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

const SocialContainer = styled(FlexColumn)`
  padding: 3px ${({ theme }) => theme.spacing["spacing-none"].value}rem;
`;
